import Vue from 'vue'
import moment from "moment";


Vue.filter('date', (date) => {
    if (date) {
        return moment(date).format('DD.MM.YYYY');
    } else {
        return '';
    }
});

Vue.filter('datetime', (datetime) => {
    if (datetime) {
        return moment(datetime).format('DD.MM.YYYY HH:mm');
    } else {
        return '';
    }
})

Vue.filter('shortDateTime', (datetime) => {
    if (datetime) {
        return moment(datetime).format('DD.MM. HH:mm');
    } else {
        return '';
    }
})

Vue.filter('time', (datetime) => {
    if (datetime) {
        return moment(datetime).format('HH:mm');
    } else {
        return '';
    }
})
